import { TextInput } from "react-admin";
export const searchFilters = [
  <TextInput key="search" label="Search" source="q" alwaysOn />,
];
